import { render, staticRenderFns } from "./ResultsImport.vue?vue&type=template&id=4f88c0e3&scoped=true"
import script from "./ResultsImport.vue?vue&type=script&lang=js"
export * from "./ResultsImport.vue?vue&type=script&lang=js"
import style0 from "./ResultsImport.vue?vue&type=style&index=0&id=4f88c0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88c0e3",
  null
  
)

export default component.exports